__webpack_require__.p = "https://7schlaefer.app/frontend/";